import { Component, OnInit, Input } from '@angular/core';
import { Announcement } from '@tytapp/models';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { AnnouncementsService } from '../announcements.service';
import { UserService } from 'user';

const STATE_KEY = makeStateKey('announcements-block');

@Component({
  selector: 'tyt-announcements-block',
  templateUrl: './announcements-block.component.html',
  styleUrls: ['./announcements-block.component.scss']
})
export class AnnouncementsBlockComponent implements OnInit {

  constructor(
    private announcementsService : AnnouncementsService,
    private transferState : TransferState,
    private userService: UserService
  ) { }

  announcements: Announcement[];

  audienceType : string = 'visitor';

  @Input()
  showHeader = true;

  @Input()
  compact = false;

  @Input()
  quantity: number = 5;
  
  async ngOnInit() {
    let savedState = this.transferState.get(STATE_KEY, null);

    if (savedState) {
      Object.assign(this, savedState);
    } else {
      this.announcements = <Announcement[]> await this.announcementsService.all(0, 6);
      this.transferState.set(STATE_KEY, { announcements: this.announcements });
    }

    this.audienceType = this.userService.audienceType;
  }

}
